import React, { useContext } from 'react';
import { GlobalsContext } from '../../store/Globals';

import { Container } from './styles';

const Main: React.FC = () => {
  const globals = useContext(GlobalsContext);
  const { definitions, headerHeight } = globals;
  return (
    <Container headerHeight={headerHeight}>
      <p>Welcome to {definitions.name}</p>
      <p>Version: {definitions.version}</p>
    </Container>
  );
};

export default Main;
